import { apiBase } from '../axios-client';
export var RETURN_PATH = "/customer/returns/v1";
var OMS_PATH = '/oms/customer/order/v1';
var GET_SORIS_QR_CODE = "".concat(RETURN_PATH, "/sorisqrcode");
var GET_SORIS_ORDER_NUMBER_BARCODE = "".concat(OMS_PATH, "/orderlookupbarcode");
export var getSorisQrCode = function (requestData) {
    return apiBase
        .post(GET_SORIS_QR_CODE, requestData)
        .then(function (response) {
        var _a;
        // this doesn't catch a 200 response with an error in the body, but that shouldn't happen.
        if (response.data && ((_a = response.data) === null || _a === void 0 ? void 0 : _a.sorisQrImg)) {
            return response.data;
        }
        throw new Error('No data found');
    });
};
export var getSorisOrderNumberBarcode = function (requestDate) {
    return apiBase
        .post("".concat(GET_SORIS_ORDER_NUMBER_BARCODE), requestDate)
        .then(function (response) {
        if (response.data) {
            return response.data;
        }
        throw new Error('No data found');
    });
};
